class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-icon-bubble");
        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.addEventListener("click", (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener("keydown", (event) => {
            if (event.code.toUpperCase() === "SPACE") {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add("animate", "active");
        });

        this.addEventListener(
            "transitionend",
            () => {
                const containerToTrapFocusOn = this.classList.contains("is-empty")
                    ? this.querySelector(".drawer__inner-empty")
                    : document.getElementById("cart-drawer");
                const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add("overflow-hidden");
    }

    close() {
        this.classList.remove("active");
        removeTrapFocus(this.activeElement);
        document.body.classList.remove("overflow-hidden");
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute("role", "button");
        cartDrawerNote.setAttribute("aria-expanded", "false");

        if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
            cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener("click", (event) => {
            event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
        });

        cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

    renderContents(parsedState) {
        if (this.querySelector("cart-drawer-items")) {
            this.querySelector("cart-drawer-items").renderContents(parsedState);
            this.autoClose();
        } else {
            this.renderContents(parsedState);
        }
    }

    autoClose() {
        this.open();
        setTimeout(() => this.close(), Number(this.dataset.timeout));
    }

    updateShippingDrawer(parsedState) {
        const msgText = this.querySelector("#Drawer-shipping-text");
        if (msgText) {
            let newHTML = new DOMParser().parseFromString(parsedState.sections["cart-drawer"], "text/html").querySelector("#Drawer-shipping-text");
            msgText.innerHTML = newHTML.innerHTML;
        }
        const msgProgress = this.querySelector("#Drawer-shipping-progress");
        if (msgProgress) {
            let newHTML = new DOMParser().parseFromString(parsedState.sections["cart-drawer"], "text/html");
            msgProgress.querySelector(".shipping-progress_text").innerHTML = newHTML.querySelector(".shipping-progress_text").innerHTML;
            msgProgress.querySelector(".progress-bar").style.setProperty("--width", newHTML.querySelector(".progress-bar").style.getPropertyValue("--width"));
        }
    }

    getSectionsToRender() {
        return [
            {
                id: "cart-drawer",
                section: "cart-drawer",
                selector: [".drawer__header", ".drawer__body", ".drawer__footer"],
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: [".js-cart-icon-bubble"],
            },
        ];
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
    constructor() {
        super();
        this.querySelectorAll(".cdc__prod-atc").forEach((btn) => btn.addEventListener("click", this.addCollectionProd.bind(this, btn)));
        this.cart = this.closest("cart-drawer-items");
    }

    addCollectionProd(btn) {
        btn.classList.add("loading");
        const body = JSON.stringify({
            id: Number(btn.dataset.id),
            quantity: 1,
            sections: this.cart.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    console.log(response.description);
                    return;
                }
                this.cart.renderContents(response);
            })
            .catch((error) => {
                console.error("Error:", error);
            })
            .finally(() => {
                btn.classList.remove("loading");
            });
    }
    getSectionsToRender() {
        return this.closest("cart-drawer").getSectionsToRender();
    }
}

customElements.define("cart-drawer-items", CartDrawerItems);
